/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _App = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	ReactDOM.render(React.createElement(_App.App, null), document.getElementById("root"));

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = React;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ComponentImage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentImage = exports.ComponentImage = function (_React$Component) {
	    _inherits(ComponentImage, _React$Component);
	
	    function ComponentImage() {
	        _classCallCheck(this, ComponentImage);
	
	        return _possibleConstructorReturn(this, (ComponentImage.__proto__ || Object.getPrototypeOf(ComponentImage)).apply(this, arguments));
	    }
	
	    _createClass(ComponentImage, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                component = _props.component,
	                file = _props.file;
	
	            var src = component ? "/static/images/components/" + component + "/" + file : "/static/images/base/" + file;
	
	            return React.createElement("img", {
	                className: className,
	                src: src
	            });
	        }
	    }]);
	
	    return ComponentImage;
	}(React.Component);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BackgroundImage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackgroundImage = exports.BackgroundImage = function (_React$Component) {
	    _inherits(BackgroundImage, _React$Component);
	
	    function BackgroundImage() {
	        _classCallCheck(this, BackgroundImage);
	
	        return _possibleConstructorReturn(this, (BackgroundImage.__proto__ || Object.getPrototypeOf(BackgroundImage)).apply(this, arguments));
	    }
	
	    _createClass(BackgroundImage, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                src = _props.src,
	                component = _props.component,
	                file = _props.file;
	
	            var path = file ? component ? "/static/images/components/" + component + "/" + file : "/static/images/base/" + file : src;
	            var style = {
	                backgroundImage: "url('" + path + "')"
	            };
	
	            return React.createElement("div", {
	                className: className,
	                style: style
	            });
	        }
	    }]);
	
	    return BackgroundImage;
	}(React.Component);

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.App = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Header = __webpack_require__(7);
	
	var _Panel = __webpack_require__(9);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = exports.App = function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App(props) {
	        _classCallCheck(this, App);
	
	        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	    // <Panel type='SidePanel' />
	    //                 <Panel type='SidePanel' isLeft={true} />
	    //<Panel type='SidePanel' flipped={false}/>
	
	
	    _createClass(App, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'span',
	                null,
	                React.createElement(_Header.Header, null),
	                React.createElement(
	                    'div',
	                    { className: 'wrapper' },
	                    React.createElement(_Panel.Panel, { type: 'SidePanel', flipped: true }),
	                    React.createElement(_Panel.Panel, { type: 'MainPanel' })
	                )
	            );
	        }
	    }]);
	
	    return App;
	}(React.Component);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Chat = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import * as firebase from "firebase";
	
	
	// const FIREBASE_CONFIG = {
	//     apiKey: "AIzaSyDfcL3-mCpGgUyt4Q1iWAirzTMLT3m6Ud4",
	//     authDomain: "warpprism-ebc5e.firebaseapp.com",
	//     databaseURL: "https://warpprism-ebc5e.firebaseio.com",
	//     projectId: "warpprism-ebc5e",
	//     storageBucket: "warpprism-ebc5e.appspot.com",
	//     messagingSenderId: "867636939716"
	// };
	
	var Chat = exports.Chat = function (_React$Component) {
	    _inherits(Chat, _React$Component);
	
	    function Chat(props) {
	        _classCallCheck(this, Chat);
	
	        var _this = _possibleConstructorReturn(this, (Chat.__proto__ || Object.getPrototypeOf(Chat)).call(this, props));
	
	        _this.state = {};
	
	        // this.fb = firebase  
	        //     .initializeApp(FIREBASE_CONFIG)
	        //     .database()
	        //     .ref();
	
	        // this.fb.on('value', snapshot => {  
	        //     console.log(snapshot.val());
	        // });
	        return _this;
	    }
	
	    _createClass(Chat, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", null);
	        }
	    }]);
	
	    return Chat;
	}(React.Component);

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Button = __webpack_require__(13);
	
	var _ComponentImage = __webpack_require__(2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMPONENT_NAME = "Header";
	
	var Header = exports.Header = function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	    }
	
	    _createClass(Header, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                'div',
	                { className: 'Header' },
	                React.createElement(
	                    'div',
	                    { className: 'topbar' },
	                    React.createElement(_ComponentImage.ComponentImage, {
	                        className: 'edge-left',
	                        component: COMPONENT_NAME,
	                        file: 'topbar-edge-left.png'
	                    }),
	                    React.createElement('div', { className: 'fill' }),
	                    React.createElement(_ComponentImage.ComponentImage, {
	                        className: 'edge-right',
	                        component: COMPONENT_NAME,
	                        file: 'topbar-edge-left.png'
	                    })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'logo' },
	                    React.createElement(
	                        'div',
	                        { className: 'sprite' },
	                        React.createElement('div', { className: 'glow' }),
	                        React.createElement('div', { className: 'glow' }),
	                        React.createElement(_ComponentImage.ComponentImage, {
	                            className: 'image',
	                            component: COMPONENT_NAME,
	                            file: 'logo-large.png'
	                        })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'warp' },
	                        'Warp'
	                    ),
	                    React.createElement(_ComponentImage.ComponentImage, {
	                        className: 'icon',
	                        component: COMPONENT_NAME,
	                        file: 'logo-animated.gif'
	                    }),
	                    React.createElement(
	                        'div',
	                        { className: 'prism' },
	                        'Prism'
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'tagline' },
	                        'Fast stream watching'
	                    )
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'infobar' },
	                    React.createElement(
	                        'div',
	                        null,
	                        React.createElement('script', { type: 'text/javascript', src: '//www.redditstatic.com/button/button1.js' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Header;
	}(React.Component);

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MainPanel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainPanel = exports.MainPanel = function (_React$Component) {
	    _inherits(MainPanel, _React$Component);
	
	    function MainPanel(props) {
	        _classCallCheck(this, MainPanel);
	
	        var _this = _possibleConstructorReturn(this, (MainPanel.__proto__ || Object.getPrototypeOf(MainPanel)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(MainPanel, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var options = {
	                channel: "shroud",
	                playsinline: true
	            };
	            var player = new Twitch.Player("player", options);
	            player.setVolume(0.5);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return React.createElement(
	                "div",
	                { className: "content" },
	                React.createElement("div", { className: "background" }),
	                React.createElement("div", { className: "player", id: "player" })
	            );
	        }
	    }]);
	
	    return MainPanel;
	}(React.Component);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Panel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ComponentImage = __webpack_require__(2);
	
	var _MainPanel = __webpack_require__(8);
	
	var _SidePanel = __webpack_require__(11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cx = __webpack_require__(3);
	
	var Panel = exports.Panel = function (_React$Component) {
	    _inherits(Panel, _React$Component);
	
	    function Panel() {
	        _classCallCheck(this, Panel);
	
	        return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
	    }
	
	    _createClass(Panel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                flipped = _props.flipped;
	
	            var spriteNames = ['top-left', 'top-stretch', 'top-right', 'bottom-left', 'bottom-stretch', 'bottom-right', 'left-stretch', 'right-stretch'];
	
	            var spriteMapping = {};
	            spriteNames.forEach(function (spriteName) {
	                spriteMapping[spriteName] = spriteName;
	            });
	
	            if (type === 'SidePanel') {
	                spriteNames.unshift('hose');
	                spriteMapping['hose'] = 'hose';
	            } else {
	                spriteMapping['top-right'] = 'top-left';
	                spriteMapping['right-stretch'] = 'left-stretch';
	                spriteMapping['bottom-right'] = 'bottom-left';
	            }
	
	            var frame = spriteNames.map(function (spriteName) {
	                return React.createElement(_ComponentImage.ComponentImage, {
	                    className: spriteName,
	                    component: type,
	                    file: 'optimized/' + spriteMapping[spriteName] + '.png'
	                });
	            });
	
	            var content = type === 'SidePanel' ? React.createElement(_SidePanel.SidePanel, { flipped: flipped }) : React.createElement(_MainPanel.MainPanel, null);
	
	            return React.createElement(
	                'div',
	                { className: cx({
	                        'Panel': true,
	                        'left': flipped,
	                        'right': !flipped,
	                        'SidePanel': type === 'SidePanel',
	                        'MainPanel': type === 'MainPanel'
	                    }) },
	                React.createElement('div', { className: 'glow' }),
	                React.createElement('div', { className: 'glow' }),
	                content,
	                React.createElement(
	                    'div',
	                    { className: 'frame' },
	                    frame
	                )
	            );
	        }
	    }]);
	
	    return Panel;
	}(React.Component);
	
	Panel.defaultProps = {
	    classNames: {}
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RedditFrame = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _BackgroundImage = __webpack_require__(4);
	
	var _ComponentImage = __webpack_require__(2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMPONENT_NAME = "RedditFrame";
	var REDDIT_URL = "https://api.reddit.com/r/";
	var cx = __webpack_require__(3);
	
	var Tabs = {
	    HOT: 0,
	    TOP: 1,
	    NEW: 2
	};
	
	var RedditFrame = exports.RedditFrame = function (_React$Component) {
	    _inherits(RedditFrame, _React$Component);
	
	    function RedditFrame(props) {
	        _classCallCheck(this, RedditFrame);
	
	        var _this = _possibleConstructorReturn(this, (RedditFrame.__proto__ || Object.getPrototypeOf(RedditFrame)).call(this, props));
	
	        _this.state = {
	            isLoading: true,
	            selectedStory: '',
	            hotStories: [],
	            topStories: [],
	            newStories: [],
	            selectedTab: Tabs.HOT
	        };
	
	        var url = REDDIT_URL + props.subreddit;
	
	        fetch(url + "/hot").then(function (response) {
	            return response.json();
	        }).then(function (data) {
	            var stories = data.data.children.filter(function (story) {
	                return !story.data.stickied;
	            });
	            _this.setState(function (prevState) {
	                prevState.hotStories = stories;
	                prevState.isLoading = false;
	                return prevState;
	            });
	        });
	
	        fetch(url + "/new").then(function (response) {
	            return response.json();
	        }).then(function (data) {
	            var stories = data.data.children.filter(function (story) {
	                return !story.data.stickied;
	            });
	            _this.setState(function (prevState) {
	                prevState.newStories = stories;
	                return prevState;
	            });
	        });
	
	        fetch(url + "/top/?sort=top&t=week").then(function (response) {
	            return response.json();
	        }).then(function (data) {
	            var stories = data.data.children.filter(function (story) {
	                return !story.data.stickied;
	            });
	            _this.setState(function (prevState) {
	                prevState.topStories = stories;
	                return prevState;
	            });
	        });
	        return _this;
	    }
	
	    _createClass(RedditFrame, [{
	        key: 'selectStory',
	        value: function selectStory(story) {
	            var url = 'https://reddit.com' + story.data.permalink;
	            window.open(url, "s", "width= 1400, height= 1024, left=300, top=0, resizable=yes, toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=yes, copyhistory=no").blur();
	            window.focus();
	        }
	    }, {
	        key: 'selectTab',
	        value: function selectTab(tab) {
	            this.setState(function (prevState) {
	                prevState.selectedTab = tab;
	                return prevState;
	            });
	        }
	    }, {
	        key: 'renderTabs',
	        value: function renderTabs() {
	            var _this2 = this;
	
	            var _state = this.state,
	                isLoading = _state.isLoading,
	                selectedTab = _state.selectedTab;
	
	            if (isLoading) {
	                return null;
	            }
	
	            return React.createElement(
	                'div',
	                { className: 'tabs' },
	                React.createElement(
	                    'div',
	                    { className: cx({ 'tab': true, 'selected': selectedTab === Tabs.HOT }),
	                        onClick: function onClick() {
	                            _this2.selectTab(Tabs.HOT);
	                        }
	                    },
	                    'Hot'
	                ),
	                React.createElement(
	                    'div',
	                    { className: cx({ 'tab': true, 'selected': selectedTab === Tabs.NEW }),
	                        onClick: function onClick() {
	                            _this2.selectTab(Tabs.NEW);
	                        }
	                    },
	                    'New'
	                ),
	                React.createElement(
	                    'div',
	                    { className: cx({ 'tab': true, 'selected': selectedTab === Tabs.TOP }),
	                        onClick: function onClick() {
	                            _this2.selectTab(Tabs.TOP);
	                        }
	                    },
	                    'Top'
	                )
	            );
	        }
	    }, {
	        key: 'renderStories',
	        value: function renderStories() {
	            var _this3 = this;
	
	            var _state2 = this.state,
	                selectedTab = _state2.selectedTab,
	                hotStories = _state2.hotStories,
	                topStories = _state2.topStories,
	                newStories = _state2.newStories;
	
	            var stories = [];
	            if (selectedTab === Tabs.HOT) {
	                stories = hotStories;
	            } else if (selectedTab === Tabs.TOP) {
	                stories = topStories;
	            } else if (selectedTab === Tabs.NEW) {
	                stories = newStories;
	            }
	
	            stories = stories.map(function (story) {
	                return React.createElement(
	                    'div',
	                    { className: 'story', onClick: function onClick() {
	                            return _this3.selectStory(story);
	                        } },
	                    story.data.thumbnail.indexOf('http') !== 0 ? React.createElement(_BackgroundImage.BackgroundImage, {
	                        className: 'thumbnail',
	                        component: COMPONENT_NAME,
	                        file: 'placeholder.gif' }) : React.createElement(_BackgroundImage.BackgroundImage, {
	                        className: 'thumbnail',
	                        src: story.data.thumbnail }),
	                    React.createElement(
	                        'div',
	                        { className: 'description' },
	                        React.createElement(
	                            'div',
	                            { className: 'title' },
	                            story.data.title
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'domain' },
	                            '(' + story.data.domain + ')'
	                        )
	                    )
	                );
	            });
	
	            return React.createElement(
	                'div',
	                { className: 'stories' },
	                stories
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var selectedStory = this.state.selectedStory;
	
	            var url = selectedStory ? 'https://reddit.com/' + this.state.selectedStory.data.permalink : '';
	            return React.createElement(
	                'div',
	                { className: 'RedditFrame' },
	                this.renderTabs(),
	                this.renderStories()
	            );
	        }
	    }]);
	
	    return RedditFrame;
	}(React.Component);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SidePanel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _ComponentImage = __webpack_require__(2);
	
	var _RedditFrame = __webpack_require__(10);
	
	var _YouTubeFrame = __webpack_require__(12);
	
	var _Chat = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMPONENT_NAME = "SidePanel";
	var cx = __webpack_require__(3);
	
	var BUTTON_FRAMING = {
	    start: ['head', 'stretch', 'bridge-end'],
	    center: ['bridge-start', 'stretch', 'stretch', 'stretch', 'bridge-end'],
	    end: ['bridge-start', 'stretch', 'tail']
	};
	
	var SidePanel = exports.SidePanel = function (_React$Component) {
	    _inherits(SidePanel, _React$Component);
	
	    function SidePanel(props) {
	        _classCallCheck(this, SidePanel);
	
	        var _this = _possibleConstructorReturn(this, (SidePanel.__proto__ || Object.getPrototypeOf(SidePanel)).call(this, props));
	
	        _this.state = {
	            selectedMenuItem: 'end'
	        };
	        return _this;
	    }
	
	    _createClass(SidePanel, [{
	        key: 'selectMenuItem',
	        value: function selectMenuItem(menuItem) {
	            this.setState(function (prevState) {
	                prevState.selectedMenuItem = menuItem;
	                return prevState;
	            });
	        }
	    }, {
	        key: 'renderSet',
	        value: function renderSet(parts, variant) {
	            return parts.map(function (part) {
	                var path = variant ? 'menu-' + part + '-' + variant + '.gif' : 'menu-' + part + '.gif';
	                return React.createElement(_ComponentImage.ComponentImage, {
	                    className: part + " item",
	                    component: COMPONENT_NAME,
	                    file: path
	                });
	            });
	        }
	    }, {
	        key: 'renderButton',
	        value: function renderButton(styles) {
	            return [React.createElement(
	                'div',
	                { className: 'base' },
	                this.renderSet(styles)
	            ), React.createElement(
	                'div',
	                { className: 'hover' },
	                this.renderSet(styles, 'hover')
	            ), React.createElement(
	                'div',
	                { className: 'active' },
	                this.renderSet(styles, 'active')
	            )];
	        }
	    }, {
	        key: 'renderSection',
	        value: function renderSection(type, caption) {
	            var _this2 = this;
	
	            var classNames = {
	                'button': true,
	                'active': this.state.selectedMenuItem === type
	            };
	            classNames[type] = true;
	
	            return React.createElement(
	                'div',
	                { className: cx(classNames) },
	                this.renderButton(BUTTON_FRAMING[type]),
	                React.createElement(
	                    'div',
	                    { className: 'caption' },
	                    caption
	                ),
	                React.createElement('div', { className: 'target', onClick: function onClick() {
	                        return _this2.selectMenuItem(type);
	                    } })
	            );
	        }
	    }, {
	        key: 'renderMenu',
	        value: function renderMenu(start, center, end) {
	            var flipped = this.props.flipped;
	
	            return flipped ? React.createElement(
	                'div',
	                { className: 'menu' },
	                this.renderSection('start', end),
	                this.renderSection('center', center),
	                this.renderSection('end', start)
	            ) : React.createElement(
	                'div',
	                { className: 'menu' },
	                this.renderSection('start', start),
	                this.renderSection('center', center),
	                this.renderSection('end', end)
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var flipped = this.props.flipped;
	            var selectedMenuItem = this.state.selectedMenuItem;
	
	            return React.createElement(
	                'div',
	                { className: 'content' },
	                React.createElement('div', { className: 'background' }),
	                flipped ? [this.renderMenu("Games", "Streams", "Chat"), selectedMenuItem === 'end' ? React.createElement(_RedditFrame.RedditFrame, { subreddit: 'bitcoin' }) : null, selectedMenuItem === 'center' ? React.createElement(_RedditFrame.RedditFrame, { subreddit: 'ethtrader' }) : null] : [this.renderMenu(["Chat", "ChatB", "ChatC"]), React.createElement(_Chat.Chat, null)]
	            );
	        }
	    }]);
	
	    return SidePanel;
	}(React.Component);

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.YouTubeFrame = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _BackgroundImage = __webpack_require__(4);
	
	var _ComponentImage = __webpack_require__(2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var COMPONENT_NAME = "YouTubeFrame";
	var YOUTUBE_URL = "https://api.reddit.com/r/Bitcoin";
	var cx = __webpack_require__(3);
	// const gapi = require('gapi');
	
	// gapi.server.setApiKey('AIzaSyD9LYQ-jBzZ3Oi1eQdE1HH-Ee3_Duti2P0');
	// gapi.server.load('plus','v1',function(){
	//     var request = gapi.server.plus.people.get({userId: '102147307918874735077'});
	//     request.execute(function(resp){
	//         res.writeHead(200, {'Content-Type': 'text/plain'});
	//         res.end(JSON.stringify(resp));
	//     });
	// });
	
	var YouTubeFrame = exports.YouTubeFrame = function (_React$Component) {
	    _inherits(YouTubeFrame, _React$Component);
	
	    function YouTubeFrame(props) {
	        _classCallCheck(this, YouTubeFrame);
	
	        var _this = _possibleConstructorReturn(this, (YouTubeFrame.__proto__ || Object.getPrototypeOf(YouTubeFrame)).call(this, props));
	
	        _this.state = {
	            isLoading: true,
	            selectedStory: '',
	            hotStories: [],
	            topStories: [],
	            newStories: [],
	            selectedTab: Tabs.HOT
	        };
	
	        // window.gapi.client.init({
	        //     'apiKey': 'AIzaSyD9LYQ-jBzZ3Oi1eQdE1HH-Ee3_Duti2P0',
	        //     // Your API key will be automatically added to the Discovery Document URLs.
	        //     'discoveryDocs': ['https://people.googleapis.com/$discovery/rest'],
	        // }).then(function() {
	        //     // 3. Initialize and make the API request.
	        //     return gapi.client.people.people.get({
	        //         resourceName: 'people/me'
	        //     });
	        // }).then(function(response) {
	        //     console.log(response.result);
	        // }, function(reason) {
	        //     console.log('Error: ' + reason.result.error.message);
	        // });
	        return _this;
	    }
	
	    _createClass(YouTubeFrame, [{
	        key: 'render',
	        value: function render() {
	            var selectedStory = this.state.selectedStory;
	
	            var url = selectedStory ? 'https://reddit.com/' + this.state.selectedStory.data.permalink : '';
	            return React.createElement('div', { className: 'YouTubeFrame' });
	        }
	    }]);
	
	    return YouTubeFrame;
	}(React.Component);

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Button = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = exports.Button = function (_React$Component) {
	    _inherits(Button, _React$Component);
	
	    function Button(props) {
	        _classCallCheck(this, Button);
	
	        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(Button, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                caption = _props.caption,
	                _onClick = _props.onClick;
	
	
	            return React.createElement(
	                "div",
	                {
	                    className: "Button",
	                    onClick: function onClick(event) {
	                        _onClick(event);
	                    }
	                },
	                caption
	            );
	        }
	    }]);
	
	    return Button;
	}(React.Component);

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = ReactDOM;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// dist/bundle.js